import { render, staticRenderFns } from "./Waiting.vue?vue&type=template&id=5e7413e1"
import script from "./Waiting.vue?vue&type=script&lang=js"
export * from "./Waiting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e7413e1')) {
      api.createRecord('5e7413e1', component.options)
    } else {
      api.reload('5e7413e1', component.options)
    }
    module.hot.accept("./Waiting.vue?vue&type=template&id=5e7413e1", function () {
      api.rerender('5e7413e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/views/Waiting.vue"
export default component.exports